import React from 'react'

const Footer = () => {
  return (
    <main className="p-4">
      <div className="container mx-auto p-4">
        <div className="text-center  space-y-2">
          <h3 className="text-red-600"><b><u>GM.</u></b></h3>
          <p>Today I am better than yesterday and tomorrow I will be better than today,because the discipline beats intelligence!</p>
          <h4>&copy; 2024 By <span className="text-red-600">Gregory Mark.</span></h4>
        </div>
      </div>
    </main>
  )
}

export default Footer
